import { observable, runInAction } from 'mobx';
import { CampaignModel, ColumnChartModel, ContentModel, ICampaignServices, RevenueCampaignModel } from 'services/Main/campaign_services';
import { DataResponse } from 'services/response';

export type CampaignStore = {
  // ====================== CONTENT =======================================
  // Danh sách nội dung của campaign
  listContent: DataResponse<Array<ContentModel>>
  // Chi tiết nội dung
  contentDetails: DataResponse<ContentModel | undefined>

  // ====================== CAMPAIGN =======================================
  // Danh sách campaign
  listCampaign: DataResponse<Array<CampaignModel>>
  //data Biểu đồ Doanh số theo campaign
  listRevenueCampaign: DataResponse<Array<RevenueCampaignModel>>
  // Biểu đồ số lượng KH ghé thăm theo campaign
  listAppointmentCampaign: DataResponse<Array<RevenueCampaignModel>>
  // Chi tiết campaign
  campaignDetails: DataResponse<CampaignModel | undefined>

  columnChart: DataResponse<Array<ColumnChartModel>>

};

export interface ICampaignPresenter {
  createStore(): CampaignStore;

  // ======================= CONTENT ===========================================================
  // Danh sách nội dung của Campaign
  getListContent(store: CampaignStore, data: object): Promise<void>
  // Thêm mới nội dung campaign
  createContent(data: object): Promise<DataResponse<null>>
  // chi tiết nội dung
  getContentDetails(store: CampaignStore, contentId: string): Promise<void>
  // Chỉnh sửa nội dung
  editContent(data: object): Promise<DataResponse<null>>

  // ======================= CAMPAIGN ===========================================================
  // Danh sách campaign
  getListCampaign(store: CampaignStore, data: object): Promise<void>
  //Tạo chiến dịch
  createCampaign(data: object): Promise<DataResponse<null>>
  // Biểu đồ doanh số theo campaign
  getRevenueCampaign(store: CampaignStore, year: number, campaignCode?: string): Promise<void>
  // Biểu đồ số lượng KH ghé thăm theo campaign
  getAppointmentCampaign(store: CampaignStore, year: number, campaignCode?: string): Promise<void>
  // chi tiết nội dung
  getCampaignDetails(store: CampaignStore, campaignId: string): Promise<void>
  // Chỉnh sửa nội dung
  editCampaign(data: object): Promise<DataResponse<null>>

  // Biểu đồ đồ thị trong chi tiết campaign
  getDataBarChartReport(store: CampaignStore, campaignId: string): Promise<void>

  // Xuất Excel báo cáo
  exportExcelCampaign(data: object): Promise<void>
}

export function createCampaignPresenter({ campaignService }: { campaignService: ICampaignServices }): ICampaignPresenter {
  return {
    createStore: (): CampaignStore =>
      observable({
        // ======================= CONTENT ===========================================================
        // Danh sách nội dung của campaign
        listContent: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // Chi tiết nội dung
        contentDetails: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        // ======================= CAMPAIGN ===========================================================
        // Danh sách campaign
        listCampaign: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // Chi tiết campaign
        campaignDetails: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        //Doanh số theo campaign
        listRevenueCampaign: {
          data: [],
          message: '',
          isSuccess: false,
        },
        // Biểu đồ số lượng KH ghé thăm theo campaign
        listAppointmentCampaign: {
          data: [],
          message: '',
          isSuccess: false,
        },

        columnChart: {
          data: [],
          message: '',
          isSuccess: false,
        },
      }),

    // ======================= CONTENT ===========================================================
    // Danh sách nội dung của Campaign
    getListContent: async (store, data) => {
      try {
        const result = await campaignService.getListContent(data);
        runInAction(() => {
          store.listContent.data = result.data;
          store.listContent.isSuccess = result.isSuccess;
          store.listContent.message = result.message;
          store.listContent.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Thêm mới nội dung campaign
    createContent: async (data) => {
      try {
        const result = await campaignService.createContent(data);
        return result
        // runInAction(() => {
        //     store.listContent.data = result.data;
        //     store.listContent.isSuccess = result.isSuccess;
        //     store.listContent.message = result.message;
        //     store.listContent.paging = result.paging;
        // });
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },
    // chi tiết nội dung
    getContentDetails: async (store, contentId) => {
      try {
        const result = await campaignService.getContentDetails(contentId);
        runInAction(() => {
          store.contentDetails.data = result.data;
          store.contentDetails.isSuccess = result.isSuccess;
          store.contentDetails.message = result.message;
          store.contentDetails.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Chỉnh sửa nội dung
    editContent: async (data) => {
      try {
        const result = await campaignService.editContent(data);
        return result
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },
    // ======================= CAMPAIGN ============================================================================
    // Danh sách campaign
    getListCampaign: async (store, data) => {
      try {
        const result = await campaignService.getListCampaign(data);
        runInAction(() => {
          store.listCampaign.data = result.data;
          store.listCampaign.isSuccess = result.isSuccess;
          store.listCampaign.message = result.message;
          store.listCampaign.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //Tạo chiến dịch
    createCampaign: async (data) => {
      try {
        const result = await campaignService.createCampaign(data);
        return result
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },
    // Biểu đồ doanh số theo campaign
    getRevenueCampaign: async (store, year, campaignCode) => {
      try {
        const result = await campaignService.getRevenueCampaign(year, campaignCode);
        runInAction(() => {
          store.listRevenueCampaign.data = result.data;
          store.listRevenueCampaign.isSuccess = result.isSuccess;
          store.listRevenueCampaign.message = result.message;
          store.listRevenueCampaign.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Biểu đồ số lượng KH ghé thăm theo campaign
    getAppointmentCampaign: async (store, year, campaignCode) => {
      try {
        const result = await campaignService.getAppointmentCampaign(year, campaignCode);
        runInAction(() => {
          store.listAppointmentCampaign.data = result.data;
          store.listAppointmentCampaign.isSuccess = result.isSuccess;
          store.listAppointmentCampaign.message = result.message;
          store.listAppointmentCampaign.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // chi tiết nội dung
    getCampaignDetails: async (store, campaignId) => {
      try {
        const result = await campaignService.getCampaignDetails(campaignId);
        runInAction(() => {
          store.campaignDetails.data = result.data;
          store.campaignDetails.isSuccess = result.isSuccess;
          store.campaignDetails.message = result.message;
          store.campaignDetails.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Chỉnh sửa nội dung
    editCampaign: async (data) => {
      try {
        const result = await campaignService.editCampaign(data);
        return result
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },


    getDataBarChartReport: async (store, id) => {
      try {
        const result = await campaignService.getDataBarChartReport(id);
        runInAction(() => {
          store.columnChart.data = result.data;
          store.columnChart.isSuccess = result.isSuccess;
          store.columnChart.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Xuất Excel báo cáo
    exportExcelCampaign: async (data) => {
      try {
        await campaignService.exportExcelCampaign(data)
      } catch (error) {
        console.log(error);
      }
    }
  };
}
